<template>
  <Field @save="save">
    <template v-slot:view>
      {{ jobKeywords ? jobKeywords.join(', ') : "None" }}
    </template>
    <template v-slot:edit>
      <v-select dense :items="keywords" v-model="jobKeywords" multiple></v-select>
    </template>
  </Field>
</template>

<script>
import Field from "../../Field"

export default {
  name: "JobKeywords",
  permissions: ["Modify Job"],
  props: ["job"],
  components: {
    Field
  },
  methods: {
    loadKeywords() {
      this.keywords = []
      this.$BwfApi.get("setting/keywords").then(res => {
        this.keywords = res.keywords.map(keyword => {
          return {value: keyword, text: keyword}
        })
      })
    },
    save: function () {
      const data = {
        job_id: this.job.ID,
        keywords: this.jobKeywords,
      }
      this.$BwfApi.post('job', data).then(() => {
        this.$notify.toast("Keywords saved")
      }).catch(err => {
          this.$notify.error("Error saving keywords: " + err.message)
        }
      )
    },
  },
  mounted() {
    this.loadKeywords()
    this.jobKeywords = this.job.Keywords || []
  },
  data() {
    return {
      keywords: [],
      jobKeywords: [],
    }
  }
}
</script>


